import React from "react";
import moment from "moment";
import "./WantAdExpiryNote.scss";

export const SHOW_WITHIN_DAYS = 14;
export const URGENT_WITHIN_DAYS = 7;

const parseExpiry = (value) => {
  if (!value) return null;
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed : null;
};

// One formatter for every end date on screen. The date is the stored UTC
// calendar date, so the table and the status check always agree. The year only
// appears when it is not the current one, so a renewal across New Year is clear.
export const formatEndDate = (value, now = moment.utc()) => {
  const date = parseExpiry(value);
  if (!date) return null;
  return date.format(date.year() === moment.utc(now).year() ? "MMM D" : "MMM D, YYYY");
};

export const daysUntilExpiry = (value, now = moment.utc()) => {
  const expiry = parseExpiry(value);
  if (!expiry) return null;
  return expiry.clone().local().startOf("day").diff(moment(now).local().startOf("day"), "days");
};

export const expiryNote = (value, now = moment.utc()) => {
  const days = daysUntilExpiry(value, now);
  if (days === null) return null;
  const date = formatEndDate(value, now);
  if (days > SHOW_WITHIN_DAYS) return { text: `Active until ${date}`, urgent: false };
  const urgent = days <= URGENT_WITHIN_DAYS;
  if (days < 0) return { text: `End date ${date} passed`, urgent };
  if (days === 0) return { text: "Expires today", urgent };
  if (days === 1) return { text: "Expires tomorrow", urgent };
  return { text: `Expires ${date}`, urgent };
};

export const isExpiringSoon = (value, now) => {
  const days = daysUntilExpiry(value, now);
  return days !== null && days <= URGENT_WITHIN_DAYS;
};

const WantAdExpiryNote = ({ expiryDate }) => {
  const note = expiryNote(expiryDate);
  if (!note) return null;
  return (
    <span className={`want-ad-expiry-note${note.urgent ? " is-urgent" : ""}`}>
      {note.text}
    </span>
  );
};

export default WantAdExpiryNote;
